import { render, staticRenderFns } from "./DetalleCurso.vue?vue&type=template&id=391f85c4&"
import script from "./DetalleCurso.vue?vue&type=script&lang=js&"
export * from "./DetalleCurso.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCurso.vue?vue&type=style&index=0&id=391f85c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports